// extracted by mini-css-extract-plugin
module.exports = {"loginContainer":"Login_loginContainer__1vwkB","loginHeader":"Login_loginHeader__1woZA","box":"Login_box___kY0E","errorMessage":"Login_errorMessage__wldIj"};